import { render, staticRenderFns } from "./AlterationUtochPlanAbp.vue?vue&type=template&id=6314f1ba&scoped=true&"
import script from "./AlterationUtochPlanAbp.vue?vue&type=script&lang=js&"
export * from "./AlterationUtochPlanAbp.vue?vue&type=script&lang=js&"
import style0 from "./AlterationUtochPlanAbp.vue?vue&type=style&index=0&id=6314f1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6314f1ba",
  null
  
)

export default component.exports